import React from 'react';
import * as PropTypes from 'prop-types';

const H5 = ({ children }) => (
  <>
    <h5>{children}</h5>
    <style jsx>
      {`
        h1,
        h2,
        h3,
        h4,
        h5,
        h6 {
          font-family: Arial, Helvetica, sans-serif;
          font-weight: normal;
          margin: 0;
        }
      `}
    </style>
  </>
);

H5.propTypes = {
  children: PropTypes.node.isRequired,
};

export default H5;
